var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Board',{attrs:{"boardTitle":_vm.boardTitle,"businessId":_vm.businessId}})
}
var staticRenderFns = []

export { render, staticRenderFns }